export default __webpack_public_path__ + "static/media/hht1_ep03_book_wp_02.f7eead94.jpg";